const abilities = {
  READ_USERS: 'read users',
  WRITE_USERS: 'write users',
  READ_PERMISSIONS: 'read permissions',
  WRITE_PERMISSIONS: 'write permissions',
  READ_INVOICES: 'read invoices',
  READ_OPPORTUNITIES: 'read opportunities',
  WRITE_OPPORTUNITIES: 'write opportunities',
  READ_FINANCIALS: 'read financials',
  WRITE_FINANCIALS: 'write financials',
  READ_LEADS: 'read leads',
  WRITE_LEADS: 'write leads',
  READ_SALES: 'read sales',
  WRITE_SALES: 'write sales',
  READ_TIMESHEETS: 'read timesheets',
  WRITE_TIMESHETS: 'write timehseets',
  READ_STACKS: 'read stacks',
  WRITE_STACKS: 'write stacks',
  READ_PROJECT_CALCULATIONS: 'read project calculations',
  WRITE_PROJECT_CALCULATIONS: 'write project calculations'
}

export const abilityExists = (ability) => {
  return Object.values(abilities).includes(ability)
}

export default abilities
